'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _objectWithoutProperties = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _excluded = ["timeout", "signal", "headers"];
Object.defineProperty(exports, '__esModule', {
  value: true
});

var utils = require('./utils.js');

function createAdd(client) {
  function add(_x, _x2) {
    return _add.apply(this, arguments);
  }

  function _add() {
    _add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid, _ref) {
      var timeout, signal, headers, query, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              timeout = _ref.timeout, signal = _ref.signal, headers = _ref.headers, query = _objectWithoutProperties(_ref, _excluded);
              _context.next = 3;
              return client.post('pin/remote/add', {
                timeout: timeout,
                signal: signal,
                headers: headers,
                searchParams: utils.encodeAddParams(_objectSpread({
                  cid: cid
                }, query))
              });

            case 3:
              response = _context.sent;
              _context.t0 = utils;
              _context.next = 7;
              return response.json();

            case 7:
              _context.t1 = _context.sent;
              return _context.abrupt("return", _context.t0.decodePin.call(_context.t0, _context.t1));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _add.apply(this, arguments);
  }

  return add;
}

exports.createAdd = createAdd;